/**
 * Mapping pur des codes d'erreur changement de mot de passe U2106 (BL-0245).
 * Préfère la description API quand elle est présente.
 */

export const U2106_CHANGE_PASSWORD_ERROR_CODES = {
  INVALID_OLD_PASSWORD: 'BU210601',
  CONFIRMATION_MISMATCH: 'BU210602',
  VALIDATION_ERROR: 'BU210603',
  ALREADY_USED: 'BU210604',
  SSO_PATH_DISABLED: 'BU210612',
} as const;

export type U2106ChangePasswordErrorCode =
  (typeof U2106_CHANGE_PASSWORD_ERROR_CODES)[keyof typeof U2106_CHANGE_PASSWORD_ERROR_CODES];

const ERROR_I18N_KEYS: Record<U2106ChangePasswordErrorCode, string> = {
  BU210601: 'changePassword.errors.invalidOldPassword',
  BU210602: 'changePassword.errors.confirmationMismatch',
  BU210603: 'changePassword.errors.validation',
  BU210604: 'changePassword.errors.alreadyUsed',
  BU210612: 'changePassword.errors.ssoPathDisabled',
};

export type U2106ApiErrorFragment = {
  errorCode?: string;
  description?: string;
};

type TranslateFn = (key: string, options?: Record<string, unknown>) => string;

/** Résout le message à afficher : description API en priorité, sinon clé i18n locale. */
export function u2106ResolveChangePasswordErrorMessage(
  err: U2106ApiErrorFragment,
  t: TranslateFn,
  nameSpace: string,
): string {
  const description = err.description?.trim();
  if (description) {
    return description;
  }

  const code = err.errorCode as U2106ChangePasswordErrorCode | undefined;
  if (code && code in ERROR_I18N_KEYS) {
    return t(ERROR_I18N_KEYS[code], { ns: nameSpace });
  }

  return t('changePassword.errors.generic', { ns: nameSpace, errorCode: err.errorCode ?? '' });
}

/** Extrait le premier code métier BU2106 d'une liste d'erreurs API. */
export function u2106ExtractChangePasswordErrorCode(
  errors: Array<{ errorCode?: string }> | undefined,
): U2106ChangePasswordErrorCode | null {
  if (!errors?.length) {
    return null;
  }
  for (const err of errors) {
    const code = err.errorCode;
    if (code && code in ERROR_I18N_KEYS) {
      return code as U2106ChangePasswordErrorCode;
    }
  }
  return null;
}
